/**
 * The alias to this folder is system/authentication
 *
 * Consider using this file as entry point to the container.
 * Ideally, you should import, bind and register all req  required modules or components from here
 */
import components from './components'
import * as vuex from './vuexstore'

export default {
  components,
  vuex,
  'mixins': {},
}


